export const PIN = 'PinReset';
export const LINK = 'LinkReset';
